// NPM Imports
import React, { useContext, useEffect } from 'react'
import toast from 'react-hot-toast'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
import useFeaturePermissions from '../../../hooks/useFeaturePermissions'
// Component Imports
import Button from 'react-bootstrap/Button'
// JS Imports
import { saveOpportunity } from '../../../ts/data'

export default function SaveButton({
   className,
   size,
   productPerformanceEECount,
   setProductPerformanceEECount,
   productTestAccount,
   setProductTestAccount,
}) {
   const state = useQuoteContext()
   const { getString } = state
   const { hasPermission } = useFeaturePermissions()
   const permissionsSaveButton = state.featurePermissions['SaveButton']
   const permissionsSaveToAccount =
      state.featurePermissions['SaveQuoteToAccount']

   //Only display save button if not a Partner or Reseller
   if (!permissionsSaveButton.includes(state.user_role)) return
   //TODO: This is an OK way to do this, but we should eventually have a master object of product values in an opportunity that includes their default value
   const productCodeToVar = {
      performanceMan: { value: productPerformanceEECount, default: 0 },
      testAccount: { value: productTestAccount, default: false },
   }

   function productNotInNewList(productCode) {
      return productCode in state.product_list === false
   }

   return (
      <Button
         className={className}
         size={size}
         type='submit'
         onClick={() => {
            //Checks to validate the expiration date
            if (
               !state ||
               state.quoteExpirationDate === null ||
               state.quoteExpirationDate === ''
            ) {
               toast.error(
                  `Unable to save opportunity due to an invalid/missing expiration date.\nPlease update the quote expiration date and try again.`,
                  { duration: 5000 },
               )
               return
            } else if (
               state.opportunity_id.slice(0, 4) == 'ACC-' &&
               !permissionsSaveToAccount.includes(state.user_role)
            ) {
               toast.error(
                  'You do not have permission to save a Quote to an Account. Please save a Quote on an Opportunity instead.',
                  { duration: 5000 },
               )
               return
            } else {
               toast.promise(
                  saveOpportunity({
                     state,
                     hasUnlimitedDatePermission: hasPermission(
                        'UnlimitedActivationDateSelect',
                        state.user_role,
                     ),
                  }).then((response) => {
                     if (!response) return Promise.reject(null)
                     return response.json()
                  }),
                  {
                     loading: 'Saving Opportunity',
                     success: (json) => {
                        const status = json.status
                        const message = json.message
                        if (status === 'success') {
                           return message
                        } else {
                           throw new Error(message)
                        }
                     },
                     error: (error) =>
                        error
                           ? error.message ||
                             'An error occurred while saving the opportunity'
                           : null,
                  },
                  { duration: 5000 },
               )
            }
            // state.setPrevPricebookId(state.pricebookId); //TODO Uneeded and causing problems?
         }}
      >
         {getString('product.SaveButton.InputText')}
      </Button>
   )
}
